import {commitMutation, graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';

// Parameterless by design: the default mapping lives only on the server, so the page never holds its
// own copy. The recomputed set comes back on the company, exactly as it does for a bulk update.
const mutation = graphql`
	mutation resetOpportunityStageBandsMutationModernMutation($input: ResetOpportunityStageBandsInput!) {
		resetOpportunityStageBands(input: $input) {
			company {
				...opportunityStageBandsCompany_company
			}
		}
	}
`;

function getConfigs() {
	return [];
}

function commit(environment, input, onSuccess, onError) {
	const variables = {...input};

	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...variables}},
		configs: getConfigs(),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
